import { render, staticRenderFns } from "./tabela.vue?vue&type=template&id=31a913a0&scoped=true"
import script from "./tabela.vue?vue&type=script&lang=js"
export * from "./tabela.vue?vue&type=script&lang=js"
import style0 from "./tabela.vue?vue&type=style&index=0&id=31a913a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a913a0",
  null
  
)

export default component.exports